import React from "react";
import styled from "styled-components";
import PropTypes from 'prop-types';
import { FacebookShareButton, FacebookIcon, TwitterIcon, TwitterShareButton } from "react-share";

import config from '../config';


const generateTitle = (type, countries) => `${type} for ${countries.join(',')}`;

const Container = styled('div')`
  display: grid;
  grid-template-columns: 6fr 2fr;
`;

const SocialSHare = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  svg {
    margin-left: 1rem;
  }
`;

const Heading = styled('h2')`
  font-size: 2.2rem;
  font-weight: 400;
  text-transform: capitalize;
  margin-bottom: 2rem;
`

const ChartHeader = ({ location, type, countries }) => {
  const url = config.hostname + location.pathname + location.search;
  return (
    <Container>
      <Heading>{generateTitle(type, countries)}</Heading>
      <SocialSHare>
        Share this chart in:
        <FacebookShareButton url={url}>
          <FacebookIcon size={24} round />
        </FacebookShareButton>
        <TwitterShareButton url={url}>
          <TwitterIcon size={24} round />
        </TwitterShareButton>

      </SocialSHare>
    </Container>
  );
};

ChartHeader.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }).isRequired,
  type: PropTypes.oneOf(['confirmed', 'deaths', 'recovered']).isRequired,
  countries: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ChartHeader;
